<template>
    <div>
        <h1>Settings</h1>
        <p>Social Share page</p>
    </div>
</template>